
export default {
  download: {
    documentTitle: 'ORS Route',
    download: 'Download',
    downloadFileName: 'Dateiname',
    downloadFormat: 'Dateiformat',
    downloadRoute: 'Route herunterladen',
    preparingDownload: 'Download wird vorbereitet…',
    fileReady: 'Datei bereit',
    errorPreparingFile: 'Fehler bei der Vorbereitung der Datei',
    fileTooBigToBeDownloaded: 'Datei ist zu groß zum Herunterladen',
    standard: 'Standard'
  }
}
